import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
	waitingWrapper: {
		display: 'flex',
		height: '90vh',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
	},
	linearProgress: {
		width: '85vw',
	},
});

export default useStyles;
